import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import callAPI from '../../../API/callSecureAPI'

export type FeatureAdoptionOrg = {
    _id: string
    name: string
    isFavorite: boolean
    createdAt: string
    features: {
        pico: boolean
        maia: boolean
        allowedUsers: boolean
        freeTrial: boolean
    }
    usage: {
        users: number
        roadmaps: number
        valueMessages: number
        evidence: number
        activities: number
    }
    activity: {
        totalEvents: number
        lastActivity: string | null
    }
}

export type FeatureAdoptionResponse = {
    success: boolean
    data: {
        adoption: FeatureAdoptionOrg[]
        total: number
    }
}

const FIVE_MINUTES = 1000 * 60 * 5

export const useAdminFeatureAdoptionQuery = () => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    const getFeatureAdoption = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })
            const response = await callAPI('/api/admin/feature-adoption', 'get', token)
            return response
        } catch (e) {
            console.error('Error fetching feature adoption:', e)
            throw e
        }
    }

    return useQuery<FeatureAdoptionResponse>(['admin', 'feature-adoption'], getFeatureAdoption, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading,
        cacheTime: FIVE_MINUTES,
        staleTime: 60000,
        retry: 2,
    })
}
